import { axios } from '../config/axios';

const endPoint = '/project/evaluator';

const getAssignedSections = (userId) => {
    return axios.get(`${endPoint}/assigned-sections/${userId}`);
};

// POST /project/evaluator/section — create a new section assignment
const createEvaluatorSection = (body) => {
    return axios.post(`${endPoint}/section`, body);
};

// PUT /project/evaluator/section/:id — update candidate limit only
const updateEvaluatorSection = (sectionId, body) => {
    return axios.put(`${endPoint}/section/${sectionId}`, body);
};

// POST /project/evaluator/pagination — evaluator list with userId in every row
const getEvaluatorList = (body) => {
    return axios.post(`${endPoint}/pagination`, body);
};

// POST /project/evaluator/allocate-candidate — allocate eligible candidates to an evaluator's open sections
const allocateCandidate = (body) => {
    return axios.post(`${endPoint}/allocate-candidate`, body);
};

// POST /project/evaluator/evaluation-candidates — paginated list of candidates assigned to the logged-in evaluator
const getEvaluationCandidates = (body) => {
    return axios.post(`${endPoint}/evaluation-candidates`, body);
};

export {
    getAssignedSections,
    createEvaluatorSection,
    updateEvaluatorSection,
    getEvaluatorList,
    allocateCandidate,
    getEvaluationCandidates,
};
